import { createAction } from '@reduxjs/toolkit'

export const fetchDevelopers = createAction('developers/fetchDevelopers')
export const fetchCSV = createAction('developers/fetchCSV')
